import { call, put, takeLatest } from "redux-saga/effects";
import {
  GeneralUtilsAction,
  InitAction,
  PettyCashierAccountReviewAction
} from "../../actions";
import * as types from "../../actions/actionTypes";
import * as accountReviewApi from "../../api/accountReview/pettyCashierAccountReview";
import * as paymentApi from "../../api/payment/pettyCashierPayment";
import * as receiveApi from "../../api/receive/pettyCashierReceive";
import { GetFilter } from "../../hocs/accountReviewReport/components/filter/tools/getFilter";
import { toastr } from "react-redux-toastr";
import { PAYMENT, RECEIVE } from "../../constants/accountReviewTypes";
import { createBrowserHistory } from "history";
import * as transactionApi from "../../api/transaction";
import { SetMessage } from "../../assets/errorMessages";
import { PAGE_NUM } from "../../constants/filters";

export function* pettyCashierWatcherAccountReview() {
  yield takeLatest(types.PETTY_CASHIER_GET_ACCOUNT_REVIEW_REQUEST, worker);
  yield takeLatest(types.PETTY_CASHIER_REMOVE_ACCOUNT_REVIEW_REQUEST, remove);
  yield takeLatest(types.MULTI_DELETE_TRANSACTIONS_REQUEST, multiDelete);
  yield takeLatest(
    types.PETTY_CASHIER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_REQUEST,
    copyToOtherProject
  );
}

async function fetchList(account_type, pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";
  return accountReviewApi.getList(page_number, GetFilter());
}

function* worker(action) {
  try {
    const response = yield call(
      fetchList,
      action.account_type,
      action.pageNumber
    );
    yield put(PettyCashierAccountReviewAction.getSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PettyCashierAccountReviewAction.getFailure(message));
  }
}

async function removeRequest(id, account_type) {
  if (account_type === PAYMENT) {
    return paymentApi.remove(id);
  } else if (account_type === RECEIVE) {
    return receiveApi.remove(id);
  }
}

function* remove(action) {
  try {
    const response = yield call(removeRequest, action.id, action.account_type);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    const responseReq = yield call(
      fetchList,
      action.account_type,
      action.pageNumber
    );
    const history = createBrowserHistory();
    const urlParams = new URLSearchParams(window.location.search);
    const pNum = urlParams.get(PAGE_NUM);
    if (pNum !== action.pageNumber) {
      urlParams.set(PAGE_NUM, action.pageNumber);
      history.push({ search: urlParams.toString() });
    }
    yield put(PettyCashierAccountReviewAction.removeSuccess(responseReq.data));
    yield put(GeneralUtilsAction.closeConfirmForTable());
    yield put(InitAction.getSuccess({ updatePremium: response.data.premium }));
  } catch (error) {
    SetMessage(error, true);
    yield put(PettyCashierAccountReviewAction.removeFailure());
  }
}

function* multiDelete(action) {
  try {
    const response = yield call(multiDeleteRequest, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(PettyCashierAccountReviewAction.multiDeleteSuccess());
    yield put(InitAction.getSuccess({ updatePremium: response.data.premium }));
    yield put(GeneralUtilsAction.closeConfirmForTable());
    yield put(GeneralUtilsAction.toggleSelectModeForTable(false));
  } catch (error) {
    SetMessage(error, true);
    yield put(PettyCashierAccountReviewAction.multiDeleteFailure());
    yield put(GeneralUtilsAction.closeConfirmForTable());
  }
}
function multiDeleteRequest(data) {
  return transactionApi.multiDelete(data);
}

function* copyToOtherProject(action) {
  try {
    const response = yield call(copyToOtherProjectRequest, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(PettyCashierAccountReviewAction.copyToAnotherProjectSuccess());
    yield put(GeneralUtilsAction.closeConfirmForTable());
    yield put(GeneralUtilsAction.toggleSelectModeForTable(false));
  } catch (error) {
    SetMessage(error, true);
    yield put(PettyCashierAccountReviewAction.copyToAnotherProjectFailure());
    yield put(GeneralUtilsAction.closeConfirmForTable());
  }
}
function copyToOtherProjectRequest(data) {
  return transactionApi.pettyCashierCopyToAnotherProject(data);
}
